<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">应急预案制定</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item style="margin-right:10rem;" label="预案类型">
            <el-select v-model="planType" placeholder="请选择">
              <el-option
                v-for="item in plantypes"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="事件类型">
            <el-select v-model="applicableEvent" placeholder="请选择">
              <el-option
                v-for="item in fitEventTypes"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案等级">
            <el-select v-model="planLevel" placeholder="请选择">
              <el-option
                v-for="item in eventplanlevels"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案状态">
            <el-select v-model="planStatus" placeholder="请选择">
              <el-option
                v-for="item in planStatuses"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10rem;" label="预案名称">
            <el-input style="width:21.7rem;" v-model="planName"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0px;">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="planName" label="预案名称" align="center"></el-table-column>
              <el-table-column prop="planNo" label="预案编号" align="center"></el-table-column>
              <el-table-column prop="planTypeTranslated" label="预案类型" align="center"></el-table-column>
              <el-table-column prop="applicableEventTranslated" label="事件类型" align="center"></el-table-column>
              <el-table-column prop="planLevelTranslated" label="对应级别" align="center"></el-table-column>
              <el-table-column prop="preparedBy" label="制定人" align="center"></el-table-column>
              <el-table-column prop="publishDate" label="启用日期" width="160" align="center">
                <template #default="{ row }">
                  <span>{{ row.publishDate ? row.publishDate.split(' ')[0] : ''}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="planStatusTranslated" label="状态" align="center"></el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { list, remove } from "@/api/src/emergency_plan";
export default {
  name: "ZjPlanList",
  controller: "UI",
  action: "PlanList",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      plantypes: [],
      plantypedic: [],
      planType: null,
      fitEventTypes: [],
      fitEventTypedic: [],
      applicableEvent: null,
      eventplanlevels: [],
      eventplanleveldic: [],
      planLevel: null,
      planStatuses: [],
      planStatusdic: [],
      planStatus: null,
      planName: null,
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('emergency_plan_type'), //预案类型
        getDictionary('emergency_applicable_event'),//适用事件类型
        getDictionary('emergency_plan_level'), //应对等级
        getDictionary('emergency_plan_status'),//预案状态
      ])
      .then(r => {
        this.plantypes = r[0].data.records;

        this.fitEventTypes = r[1].data.records;
        
        this.eventplanlevels = r[2].data.records;
        
        this.planStatuses = r[3].data.records;
        
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
    },
    search() {
      let searchInfo = {
        size: this.pageSize,
        current: this.currentPage,
        planType:this.planType,
        applicableEvent:this.applicableEvent,
        planLevel:this.planLevel,
        planStatus:this.planStatus,
        planName:this.planName
      }
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    clearsearch() {
      this.planType = null;
      this.applicableEvent = null;
      this.planLevel = null;
      this.planStatus = null;
      this.planName = null;
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, { id }) {
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          id,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, { id }) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          id,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/ui/PlanManage",
        query: {
          id: null,
          type: "edit"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              let ids = selectData.map(item =>item.id)
              this.delete(ids.join(','))
            }
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(row.id)
        });
    },
    delete(idList){
      this.loading = true;
      this.loadingText = '删除中...';
      remove({idList}).then(r => {
        r = r.data;
        if (r) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败!"
          });
        }
        this.loading = false;
        this.search();
      })
      .catch(e => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogOk2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
    dialogCancel2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
  }
};
</script>